import { css } from '@emotion/css';
import { useOperatorContext } from '../../app/components/BaseLayoutAndData.tsx';

export function CurrentOperatorLoginText() {
    const { currentLogin } = useOperatorContext();
    return (
        <div
            className={css({
                textAlign: 'right',
                fontSize: 16,
            })}
        >
            {`${currentLogin.firstname} ${currentLogin.lastname}`}
        </div>
    );
}

export function CurrentOperatorLoginId() {
    const { currentLogin } = useOperatorContext();

    return (
        <div
            className={css({
                padding: '0 15px',
            })}
        >
            {currentLogin.mandantName} ({currentLogin.mandantId})
        </div>
    );
}
